import {
  SupplierContractCheckItemRequest,
  SupplierContractCheckItemResult,
} from '../../../../core/clients/omni-core/models';

export interface SupplierContractCheckItemFormModel {
  document: File | { url: string } | null;
  explanation: string;
  result: SupplierContractCheckItemResult;
}

export const toModel = (
  res: SupplierContractCheckItemRequest | null,
): SupplierContractCheckItemFormModel => {
  return {
    document: res?.documentId ? { url: res.documentId } : null,
    explanation: res?.explanation ?? '',
    result: res?.result ?? 'NOT_SET',
  };
};

export const toPayload = (
  data: SupplierContractCheckItemFormModel,
): SupplierContractCheckItemRequest => {
  return {
    result: data.result,
    explanation: data.explanation || undefined,
  };
};
